// extracted by mini-css-extract-plugin
export var addToCartButton = "_px-b";
export var arrowButtonContainer = "_px-9";
export var arrowButtonIcon = "_px-a";
export var carouselArrowButton = "_px-6";
export var carouselElementContainer = "_px-1";
export var left = "_px-7";
export var productDisplayCarouselContainer = "_px-0";
export var productTileContainer = "_px-2";
export var productTileImage = "_px-4";
export var productTileImageContainer = "_px-3";
export var productTileTitle = "_px-5";
export var right = "_px-8";
export var sliderOverflow = "_px-c";